import * as React from 'react'
import * as PropTypes from 'prop-types'
import { css, Rule } from 'glamor'

import { VisibilityProvider } from '../../utils/visibility-fade'

interface IFadeInProps {
  children: React.ReactNode
  style?: Rule
  direction?: 'up' | 'down'
}

export class FadeIn extends React.Component<IFadeInProps> {
  static propTypes = {
    children: PropTypes.node.isRequired,
    style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    direction: PropTypes.oneOf(['up', 'down']),
  }
  static defaultProps = {
    direction: 'down',
  }

  render() {
    const { children, style, direction, ...rest } = this.props

    return (
      <VisibilityProvider>
        {({ visible }) => (
          <div
            {...rest}
            {...css(
              {
                opacity: visible ? 1 : 0,
                transition: 'all 0.2s ease-in-out',
                transform: visible ? `translateY(${0}px)` : `translateY(${direction === 'down' ? -10 : 10}px)`,

                '@media (prefers-reduced-motion: reduce)': {
                  transition: 'none',
                  transform: 'none',
                },
              },
              style
            )}
          >
            {children}
          </div>
        )}
      </VisibilityProvider>
    )
  }
}
